export enum UsersSettings {
  sidePanelOpened = 'sidePanelOpened'
}
